export const CryptoConfig = {
  cryptSalt: import.meta.env.VITE_CRYPT_SALT
}
